import React, {useState} from "react";
import ReactApexChart from "react-apexcharts";
import { Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react/lib/Shimmer';
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { countBy, unique } from "../../common/Helpers";
import useSetChartDataVariable from "../../hooks/component/useOfAccessesPerMonthStack";
import PropTypes from 'prop-types';

const AccessesPerMonthStack = (props) => {

  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  const __chartData_mandant = [
    {name : '1/' + currentYear, count: 0},
    {name : '2/' + currentYear, count: 0},
    {name : '3/' + currentYear, count: 0},
    {name : '4/' + currentYear, count: 0},
    {name : '5/' + currentYear, count: 0},
    {name : '6/' + currentYear, count: 0},
    {name : '7/' + currentYear, count: 0},
    {name : '8/' + currentYear, count: 0},
    {name : '9/' + currentYear, count: 0},
    {name : '10/' + currentYear, count: 0},
    {name : '11/' + currentYear, count: 0},
    {name : '12/' + currentYear, count: 0},
  ];

  const __chartData_eecc = [
    {name : '1/' + currentYear, count: 0},
    {name : '2/' + currentYear, count: 0},
    {name : '3/' + currentYear, count: 0},
    {name : '4/' + currentYear, count: 0},
    {name : '5/' + currentYear, count: 0},
    {name : '6/' + currentYear, count: 0},
    {name : '7/' + currentYear, count: 0},
    {name : '8/' + currentYear, count: 0},
    {name : '9/' + currentYear, count: 0},
    {name : '10/' + currentYear, count: 0},
    {name : '11/' + currentYear, count: 0},
    {name : '12/' + currentYear, count: 0},
  ];
  
  const inputParam_ChartData = props.chartData !== undefined && props.chartData !== null ? props.chartData : null;

  const _aux_chartData_mandant = inputParam_ChartData !== null ? inputParam_ChartData.filter(x => x.legalEntityTypeId === 1) : null;
  const _aux_chartData_eecc = inputParam_ChartData !== null ? inputParam_ChartData.filter(x => x.legalEntityTypeId !== 1) : null;
  
  const _aux_chartData_mandant_groupedByDate = _aux_chartData_mandant !== null ? countBy(_aux_chartData_mandant, "fecha") : null;
  const _aux_chartData_eecc_groupedByDate = _aux_chartData_eecc !== null ? countBy(_aux_chartData_eecc, "fecha") : null;



  const final_aux_chartData_mandant_groupedByDate = [];
  for(let key1 in _aux_chartData_mandant_groupedByDate){
    final_aux_chartData_mandant_groupedByDate.push({
        name  : key1,
        count : _aux_chartData_mandant_groupedByDate[key1]
    });
  }

  const final_aux_chartData_eecc_groupedByDate = [];
  for(let key1 in _aux_chartData_eecc_groupedByDate){
    final_aux_chartData_eecc_groupedByDate.push({
        name  : key1,
        count : _aux_chartData_eecc_groupedByDate[key1]
    });
  }

  _aux_chartData_mandant_groupedByDate &&
  __chartData_mandant.forEach(element => {
    for (let _aux_element of final_aux_chartData_mandant_groupedByDate) {
      if(element.name === _aux_element.name) {
        element.count = _aux_element.count;
        break;
      }
    }
  });

  _aux_chartData_eecc_groupedByDate &&
  __chartData_eecc.forEach(element => {
    for (let _aux_element of final_aux_chartData_eecc_groupedByDate) {
      if(element.name === _aux_element.name) {
        element.count = _aux_element.count;
        break;
      }
    }
  });

  const __chartData_mandant_final = [];
  const __chartData_eecc_final = [];

  for (let index = 0; index < 11; index++) {
    if (__chartData_mandant[index].count > 0 || __chartData_eecc[index].count > 0) {
      __chartData_mandant_final.push(__chartData_mandant[index]);
      __chartData_eecc_final.push(__chartData_eecc[index]);
    }
  }

  const mandant_groupedByDate_count = __chartData_mandant_final.map(x => x.count);
  const eecc_groupedByDate_count = __chartData_eecc_final.map(x => x.count);
  const _aux_chartData_dates = inputParam_ChartData !== null ? inputParam_ChartData.map(x => x.fecha).filter(unique) : null;

  const [chartData, setChartData] = useState(null);        
  useSetChartDataVariable(inputParam_ChartData, [{ name: t('data-lang-charts-eecc'), data: eecc_groupedByDate_count }, { name: t('data-lang-charts-mandant'), data: mandant_groupedByDate_count }], _aux_chartData_dates, chartData, setChartData)

    return (
      <>  
        {chartData && 
          <ReactApexChart options={chartData.options} series={chartData.series} type="bar" width="100%" height="250px" />
        }
        {!chartData && 
          <Shimmer
              customElementsGroup={
                <Row style={{ display: 'flex' }}>
                  <Col>
                  <ShimmerElementsGroup
                      shimmerElements={[
                          { type: ShimmerElementType.line, width: 50, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 170,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 120,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 150, verticalAlign: 'bottom'},
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 240, verticalAlign: 'bottom'},
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 30,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                          { type: ShimmerElementType.line, width: 150, height: 100, verticalAlign: 'bottom'},
                          { type: ShimmerElementType.line, width: 150, height: 5,  verticalAlign: 'bottom' },
                      ]}
                  />
                  </Col>
                </Row>
              }
              className="pt-4"
              isDataLoaded={chartData !== null}>
          </Shimmer>
        }
      </>
    );
};
AccessesPerMonthStack.propTypes = {
  chartData: PropTypes.object.isRequired,
};
export default AccessesPerMonthStack;